<template src="./CustomPage.html"></template>
<script>
  export default {
    data () {
      return {
        dato: 'Dato del componente'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/CustomPackage/pages/CustomPage/CustomPage.vue